import { semantic } from './preset/semantic';
import { components } from './preset/components';
import { primitive } from './preset/primitive';
import { definePreset } from '@primeuix/themes';
import { arsktrpTheme } from 'arsktrp-shared-styles';

export const evtTheme = definePreset(arsktrpTheme, {
  primitive,
  semantic,
  components,
});
